import { ColumnsType } from "antd/es/table";
import IsDataNull from "../../Template/IsDataNull";
import DownloadPack from "./DownloadPack";
import IsDataNullWrap from "../../Template/IsDataNullWrap";

interface DownloadTableColumnProps {
  id: number;
  id_pack: number;
  date_created: string;
  created_by: string;
  template: string;
  status: string;
}

const DownloadTableColumn: ColumnsType<DownloadTableColumnProps> = [
  {
    title: "Created By ",
    key: "createdBy",
    dataIndex: "createdBy",
    render: (data) => <IsDataNull data={data} />,
    width: 100,
  },
  {
    title: "Created At ",
    key: "template",
    dataIndex: "dateCreated",
    render: (data) => <IsDataNull data={data} />,
    width: 100,
  },
  {
    title: "Template ",
    key: "template",
    dataIndex: "template",
    render: (data) => <IsDataNullWrap data={data} />,
    width: 60,
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    render: (data) => <IsDataNull data={data} />,
    width: 100,
  },
  {
    title: "Action",
    key: "action",

    dataIndex: "action",
    align: "center",
    render: (data, record) => (
      <DownloadPack
        id={record.id}
        status={record.status}
      />
    ),
    width: 70,
  },
];

export default DownloadTableColumn;
